import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/AppointmentDetailScreen.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import api from "../api";
import { toast } from "react-toastify";
import PawAnimation from "./PawAnimation";
import { AnimatePresence, motion } from "framer-motion";

export default function AppointmentDetailScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const doctorId = location.state?.doctorId;

  const [summary, setSummary] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleBack = () => navigate(-1);

  useEffect(() => {
    if (!doctorId) {
      toast.error("Doctor ID not found!");
      navigate(-1);
      return;
    }

    const fetchDoctorAppointments = async () => {
      try {
        const response = await api.get(`/doctor-profiles/${doctorId}`);
        const data = response.data;

        setSummary(data.appointment_fee_collection_summary);
        setAppointments(data.appointments || []);
      } catch (error) {
        console.error("Error fetching appointments:", error);
        toast.error("Failed to fetch appointment details.");
      } finally {
        setLoading(false);
      }
    };

    fetchDoctorAppointments();
  }, [doctorId, navigate]);

  if (loading) {
    return (
      <AnimatePresence>
        <motion.div
          className="full-screen-loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <PawAnimation />
        </motion.div>
      </AnimatePresence>
    );
  }

  if (!summary) {
    return (
      <div className="container">
        <Sidebar />
        <div className="main">
          <Header />
          <div className="main-content">
            <p>No appointment data available.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <Sidebar />
      <div className="main">
        <Header />
        <div className="main-content">
          <div className="heading_title">
            <PageTitle title="Appointment Details" onBack={handleBack} />
          </div>

          {/* Appointment Summary Card */}
          <div className="appointment-summary-card">
            <h3 className="summary-title">Appointment Fee Collection Summary</h3>
            <div className="summary-item">
              <span>Overall Appointments:</span>
              <span className="summary-value">
                {summary.overall_appointment ?? 0}
              </span>
            </div>
            <div className="summary-item">
              <span>Overall Doctor Fees:</span>
              <span className="summary-value">
                ₹{summary.overall_doctor_fees?.toLocaleString() ?? "0"}
              </span>
            </div>
            <div className="summary-item">
              <span>Pawfriends Commission:</span>
              <span className="summary-value">
                {summary.pawfriends_commission_percentage ?? 0}%
              </span>
            </div>
            <div className="summary-item">
              <span>Pawfriends Profit:</span>
              <span className="summary-value">
                ₹{summary.pawfriends_profit?.toLocaleString() ?? "0"}
              </span>
            </div>
          </div>

          {/* Appointment Table */}
          <div className="appointment-table">
            <table>
              <thead>
                <tr>
                  <th>Appointment Date & Time</th>
                  <th>Pet Owner’s Name</th>
                  <th>Pet Details</th>
                  <th>Service Availed</th>
                  <th>Appointment Status</th>
                  <th>Paid Amount</th>
                </tr>
              </thead>
              <tbody>
                {appointments.length > 0 ? (
                  appointments.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.appointment_date} at{" "}
                        {item.appointment_time?.slice(0, 5)}
                      </td>
                      <td>{item.pet_owner_name}</td>
                      <td>
                        {item.pet_details?.name},{" "}
                        {item.pet_details?.category}{" "}
                        {item.pet_details?.breed}
                      </td>
                      <td>{item.service_availed || "N/A"}</td>
                      <td
                        className={`AD_status ${item.appointment_status
                          ?.replace(" ", "")
                          .toLowerCase()}`}
                      >
                        {item.appointment_status}
                      </td>
                      <td>₹{item.paid_amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No appointments found for this doctor.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
